const LINE_HEIGHT = '1.5rem';

export { LINE_HEIGHT };
